module.exports = __webpack_public_path__ + "static/media/btn-help.2d6c0065.svg";